import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ActivityAction } from '@stores/activity/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import Avatar from '@components/avatar';
import VoteList from '@components/voteList';
import { formatTime } from '@utils/timeUtils';
import AvatarList from '@components/avatarList';
import { BASE_IMG_URL } from '@images/imageUrls';
import CommonPopup from '@components/commonPopup';
import CommonAlert from '@components/commonAlert';

import classNames from 'classnames';
import {Radio, Input, DatePickerProps, DatePicker } from 'antd';
const { TextArea } = Input;
import parse from 'html-react-parser';
import Toast from '@components/Toast';
import PostList from '@components/postList';

interface ActivityDetailH5PageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    activity?: ActivityAction;
    activityId: any
    createFollowUser?: any
    followDelete?: any
    createActivityVote?: any
    likeClick?: any
    favoriteClick?: any
    postsUpdate?: (id: any, actionType: 'delete' | 'sink' | 'sticky', type: 'post' | 'comment', currentState?: boolean) => Promise<any>
}
interface ActivityDetailH5State {
    loading: boolean;
    error: any
    pageLoaded: any
    topicList?: any
    rewardPopupStatus: boolean
    rewardList: any
    rewardCheckValue: any
    reportPopupStatus: any
    reportReasonList: any
    reportReason: any
    reportDescription: any
    reportType?: any
    menuDropStatus: any
    selectedCommentId?: any
    selectedCommentIsSink?: boolean
    selectedCommentIsSticky?: boolean
    deletePopupStatus?: boolean
    
}
@inject('app', 'site', 'user', 'activity')
@observer
class ActivityDetailH5Page extends BasePage<ActivityDetailH5PageProps, ActivityDetailH5State> {
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        topicList: [],
        rewardPopupStatus: false,    // 打赏弹框
        rewardList: [], // 打赏选项数组
        rewardCheckValue: 0,    // 打赏V币数
        reportPopupStatus: false,    // 举报弹框
        // reportReasonList: ['淫秽色情', '垃圾广告', '垃圾广告', '违规传播', '政治谣言', '谩骂侮辱', '灌水发帖/评论', '其他' ], // 举报理由的类型
        reportReasonList:[
            { value: '淫秽色情', label: '淫秽色情' },
            { value: '垃圾广告', label: '垃圾广告' },
            { value: '暴力恐怖', label: '暴力恐怖' },
            { value: '违规传播', label: '违规传播' },
            { value: '政治谣言', label: '政治谣言' },
            { value: '谩骂侮辱', label: '谩骂侮辱' },
            { value: '灌水发帖/评论', label: '灌水发帖/评论' },
            { value: '其他', label: '其他' },
        ],
        reportReason: '',   // 举报理由
        reportDescription: '',  // 举报描述
        reportType: 4,  // 举报类型0 个人主页 1 主题 2 评论/回复 3 问题反馈 4 活动 5 私信
        menuDropStatus: false,  // 标题右侧管理下拉框状态，默认折叠
        selectedCommentId: undefined,  // 当前选中要操作的评论 id
        selectedCommentIsSink: false,
        selectedCommentIsSticky: false,
        deletePopupStatus: false,  // 删除弹框状态
    };
    componentDidMount() {
        const { app, user, thread, threadId, site } = this.props as any;
        
        // if (thread) {
        //     thread.getThreadDetail(threadId)
        // }
        // 首屏预取表情数据（站点级）
        // if (site && !site.hasEmoji && !site.isEmojiLoading && typeof site.fetchEmoji === 'function') {
        //     site.fetchEmoji();
        // }
        super.componentDidMount();
    }

    // 跳转到帖子详情页
    handleThreadClick = (item: any) => {
        // if(item.type == 3) {    // 是活动
        //     this.props.history && this.props.history.push(`/activityDetail/${item.id}`);
        // } else {    // 是其他
        //     this.props.history && this.props.history.push(`/threadDetail/${item.id}`);
        //     window.open(`/threadDetail/${item.id}`);
        // }  
        window.open(`/threadDetail/${item.id}`);
    };
    // 确认投票
    handleVoteSubmit = (selectedOptions: string[]) => {
        // console.log('用户选择了:', selectedOptions);
        // 这里可以发送到后端API
    };
    // 投票选择
    handleVoteChange = (selected: string[]) => {
        // console.log('选择变化:', selected);
    };

    // 打开打赏弹框
    openRewardPopup = () => {
        this.setState({
            rewardPopupStatus: true
        })
    }
    // 关闭所有弹框
    closePopup = () => {
        // Toast.info('关闭')
        this.setState({
            rewardPopupStatus: false,   // 打赏弹框
            reportPopupStatus: false,   // 举报弹框
            menuDropStatus: false,  //右上角下拉框
        })
    }
    // 确定打赏
    rewardConfirm = () => {
        let { rewardCheckValue } = this.state;
        if(rewardCheckValue == 0) {
            Toast.info('请选择打赏V币数');
            return false;
        }
        const { activity, activityId } = this.props;
        if (activity) {
            let params: any = {
               id: activityId,
               type: 2, // 0是主题
               scoreReward: rewardCheckValue,
               source: 'PC'
            }
            activity.postsCreate(params).then(res => {
                if(res.code === 0) {
                    this.setState({
                        rewardPopupStatus: false,   // 打赏弹框
                    })
                } else {
                    Toast.info(res.msg);
                }
                
            })
        }
    }

    // 确定举报
    reportConfirm = () => {
        let { activityId } = this.props;
        let { reportReason, reportType, selectedCommentId } = this.state;
        if(reportReason == '') {
            Toast.info('请选择举报理由');
            return false;
        }
        const { activity } = this.props;
        if (activity) {
            let params: any = {
               id: reportType == 4 ? activityId : selectedCommentId,
               type: reportType, // 0 个人主页 1 主题 2 评论/回复 3 问题反馈 4 活动 5 私信
               reason: reportReason
            }
            activity.createReports(params).then(res => {
                this.setState({
                    reportPopupStatus: false,   // 举报弹框
                    menuDropStatus: false,  // 举报下拉框收起
                })
            })
        }
    }

    // 当前活动用户信息
    activityUserInfo = (user: any) => {
        const { activity, activityId } = this.props;
        let { menuDropStatus } = this.state;
        const activityData = activity?.activityData;
        const isFollowed = activityData?.user?.isFollow;
        // 是否作者本人
        const isSelf = user?.userInfo?.code && user?.userInfo?.code === activityData?.user?.code;
        return (
            <div className={styles.userInfoBox}>
                {/* 活动作者、管理 */}
                <Avatar avatarUrl={user?.avatar} titleMark={user?.titleMark} size={60}></Avatar>
                <div className={styles.infoBox}>
                    <div className={styles.infoDetail}>
                        <div className={styles.userNameBox}>
                            <div className={styles.userName}>{user?.nickname}</div>
                            {user?.titleName && <div className={styles.userTitle}>{user?.titleName}</div>}
                        </div>
                        {activityData?.source && <div className={styles.userModel}>{activityData?.source}</div>}
                    </div>
                    {!isFollowed ? (
                        <div className={styles.followBtn} onClick={() => this.props.createFollowUser()}>关注</div>
                    ) : (
                        <div className={styles.followedBtn} onClick={() => this.props.followDelete && this.props.followDelete()}>已关注</div>
                    )}
                    
                    {/* <div className={styles.menuBox}>
                        <img src={`${BASE_IMG_URL}/common/menu2.png`} alt='管理' className={styles.menuIcon} onClick={()=> {
                            this.setState({
                                menuDropStatus: !menuDropStatus
                            })
                        }} />
                        
                    </div> */}
                </div>
                
            </div>
        )
    }

    render() {
        const { activity } = this.props;
        let { rewardPopupStatus, rewardList, rewardCheckValue, reportPopupStatus, reportReasonList, menuDropStatus } = this.state;
        if (!activity) { return <div>加载中...</div>}
        const activityData = activity.activityData;
        const voteData = {
            question: "用vivo X300手机直播音乐节时，开启哪个设置能2.85%?",
            options: [
                { id: 'A', label: 'A', value: '关闭5G', votes: 125, percentage: 25 },
                { id: 'B', label: 'B', value: '调低屏幕亮度', votes: 375, percentage: 75 },
                { id: 'C', label: 'C', value: '禁用AI美化', votes: 0, percentage: 0 },
                { id: 'D', label: 'D', value: '省电模式', votes: 0, percentage: 0 }
            ],
            mode: 'single' as const,
            onSubmit: this.handleVoteSubmit,
            onVoteChange: this.handleVoteChange,
            hasVoted: false, // 初始状态
            totalVotes: 500,
            endAt: '2025-12-2 16:23:00',
        };
        let options = {};
        const parserOptions = {
            replace: (domNode: any) => {
                // 可以在这里自定义节点替换逻辑
                if (domNode.name === 'img') {
                    // return (
                    // <img 
                    //     {...domNode.attribs} 
                    //     loading="lazy"
                    //     onError={(e) => {
                    //     e.currentTarget.style.display = 'none';
                    //     }}
                    // />
                    // );
                }
            },
            ...options
        };
        return (
            <div className={styles.wrapper}>
                <div className={styles.titleBox}></div>
                {/* 活动作者 */}
                {this.activityUserInfo(activityData?.user)}

                {/* 活动内容 */}
                <div className={styles.threadContentBox}>
                    <div className={styles.richeText}>
                        {parse(activityData?.content || '', parserOptions)}
                    </div>
                    {/* 投票 */}
                    <div className={styles.voteBox}>
                        {/* <VoteList {...voteData} /> */}
                    </div>
                    {/* 活动合集 */}
                    <div className={styles.collectionList}>
                        {activityData?.collection?.map((item:any)=> (
                            <div className={styles.collectionItem}>
                                {item.coverUrl != '' && <img src={item.coverUrl} alt="" className={styles.collectionCover} onClick={() => this.handleThreadClick(item)} />}
                                <div className={styles.collectionDetail}>
                                    <div className={styles.collectionTitle} onClick={() => this.handleThreadClick(item)}>{item.title || item.summary}</div>
                                    <div className={styles.collectionInfo}>
                                        <div className={styles.collectionUserBox}>
                                            <Avatar avatarUrl={item.avatar} titleMark={item?.titleMark} size={32}></Avatar>
                                            <div className={styles.name}>{item.user?.nickname}</div>
                                        </div>
                                        <div className={styles.infoOperaBox}>
                                            <div className={styles.operaItem} onClick={() => this.handleThreadClick(item)}>
                                                <img src={`${BASE_IMG_URL}/common/comment.png`} alt="" className={styles.icon}/>
                                                <div className={styles.count}>{item.postCount}</div>
                                            </div>
                                            <div className={styles.operaItem} onClick={() => this.handleThreadClick(item)}>
                                                <img src={`${BASE_IMG_URL}/common/like.png`} alt="" className={styles.icon}/>
                                                <div className={styles.count}>{item.likeCount}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className={styles.topicList}>
                        {activityData?.topics?.map((topic:any)=> (
                            <span className={styles.topicName} onClick={() => {
                                this.props.history && this.props.history.push(`/topicDetail/${topic.id}`);
                            }}>{topic.name}</span>
                        ))}
                    </div>
                    <div className={styles.threadBottomInfo}>
                        <div className={styles.postTime}>{formatTime(activityData?.createdAt)}</div>
                        {/* <div className={styles.postArea}>IP所属区域</div> */}
                    </div>

                    {/* 操作按钮 */}
                    <div style={{display: 'flex', justifyContent: 'space-around', padding: '15px 0', borderBottom: '1px solid #eee'}}>
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}} onClick={() => this.props.likeClick && this.props.likeClick(activityData)}>
                            <img src={activityData?.isLiked ? `${BASE_IMG_URL}/common/liked.png` : `${BASE_IMG_URL}/common/like1.png`} alt="" style={{width: '24px', height: '24px', marginBottom: '4px'}} />
                            <div style={{fontSize: '12px', color: '#999'}}>{activityData?.likeCount}</div>
                        </div>
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}} onClick={() => this.props.favoriteClick && this.props.favoriteClick(activityData?.isFavorite)}>
                            <img src={activityData?.isFavorite ? `${BASE_IMG_URL}/common/favorited.png` : `${BASE_IMG_URL}/common/favorite.png`} alt="" style={{width: '24px', height: '24px', marginBottom: '4px'}} />
                            <div style={{fontSize: '12px', color: '#999'}}>{activityData?.favoriteCount}</div>
                        </div>
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                            <img src={`${BASE_IMG_URL}/common/comment1.png`} alt="" style={{width: '24px', height: '24px', marginBottom: '4px'}} />
                            <div style={{fontSize: '12px', color: '#999'}}>{activityData?.postCount}</div>
                        </div>
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                            <img src={`${BASE_IMG_URL}/common/share.png`} alt="" style={{width: '24px', height: '24px', marginBottom: '4px'}} />
                            <div style={{fontSize: '12px', color: '#999'}}>{activityData?.shareCount}</div>
                        </div>
                    </div>

                    <div className={styles.postListBox}>
                        <PostList 
                            threadId={this.props.activityId} 
                            threadType={2}
                            commentType={2}
                            handleSetState={(data, rep) => this.setState({ ...data },()=>{
                                console.log('handleSetState-data',data)
                            })}
                            onPostLike={(comment) => {
                                window.globalEnsureLogin(() => this.props.likeClick?.(comment, 'post'));
                            }}
                            onDeleteComment={async (itemId) => {
                                this.setState({ selectedCommentId: itemId });
                                try {
                                    await this.props.postsUpdate?.(itemId, 'delete', 'comment');
                                    Toast.success({ content: '删除成功' });
                                } catch (error) {
                                    Toast.error({ content: '删除失败' });
                                }
                            }}
                            onSinkComment={async (itemId, currentIsSink) => {
                                this.setState({ selectedCommentId: itemId, selectedCommentIsSink: currentIsSink });
                                try {
                                    await this.props.postsUpdate?.(itemId, 'sink', 'comment', currentIsSink);
                                    Toast.success({ content: currentIsSink ? '取消沉贴成功' : '沉贴成功' });
                                } catch (error) {
                                    Toast.error({ content: currentIsSink ? '取消沉贴失败' : '沉贴失败' });
                                }
                            }}
                            onStickyComment={async (itemId, currentIsSticky) => {
                                this.setState({ selectedCommentId: itemId, selectedCommentIsSticky: currentIsSticky });
                                try {
                                    await this.props.postsUpdate?.(itemId, 'sticky', 'comment', currentIsSticky);
                                    Toast.success({ content: currentIsSticky ? '取消置顶成功' : '置顶成功' });
                                } catch (error) {
                                    Toast.error({ content: currentIsSticky ? '取消置顶失败' : '置顶失败' });
                                }
                            }}
                        ></PostList>
                        {/* 举报弹框 */}
                        <CommonPopup
                            visible={reportPopupStatus}
                            title="举报"
                            onCancelChange={() => this.closePopup()}
                            onConfirmButtonChange={() => this.reportConfirm()}
                        >
                            {/* children 插槽内容 */}
                            <div className={styles.reportPopupSlotBox}>
                                <div className={styles.reportText}>
                                    <span className={styles.must}>*</span>举报理由
                                    <span>请选择举报理由</span>
                                </div>
                                <div className={styles.reportReasonListBox}>
                                    <Radio.Group
                                        name="radiogroup"
                                        defaultValue={1}
                                        onChange={(e) => {
                                            this.setState({
                                                reportReason: e.target.value,
                                            });
                                        }}
                                        options={reportReasonList}
                                    />
                                </div>
                                <div className={styles.reportText}>举报描述</div>
                                <TextArea rows={4} placeholder="请输入举报理由" maxLength={600} />
                            </div>
                        </CommonPopup>
                    </div>
                </div>
            </div>
        ) 
    }
}

export default withRouter(ActivityDetailH5Page);
